import PlusNewFeatures from './PlusNewFeatures';

export default PlusNewFeatures;
